import { render, staticRenderFns } from "./UserInvitation.vue?vue&type=template&id=f3c040b8&"
import script from "./UserInvitation.vue?vue&type=script&lang=js&"
export * from "./UserInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports